import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flux-wrap" }
const _hoisted_2 = { class: "flux-title" }
const _hoisted_3 = {
  key: 0,
  class: "flux-loading"
}
const _hoisted_4 = {
  key: 1,
  class: "flux-loading"
}
const _hoisted_5 = {
  key: 2,
  class: "stepper"
}
const _hoisted_6 = { class: "step-marker" }
const _hoisted_7 = {
  key: 0,
  class: "step-line"
}
const _hoisted_8 = { class: "step-body" }
const _hoisted_9 = { class: "step-row" }
const _hoisted_10 = { class: "step-rol" }
const _hoisted_11 = { class: "step-name" }
const _hoisted_12 = {
  key: 0,
  class: "step-meta"
}
const _hoisted_13 = {
  key: 1,
  class: "step-nota"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "16",
        color: "#ff5722",
        class: "mr-2"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("mdi-transit-connection-variant", -1)
        ]))]),
        _: 1
      }),
      _cache[1] || (_cache[1] = _createTextVNode(" Flux de aprobare ", -1))
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "20",
            color: "#ff5722"
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" Se încarcă… ", -1))
        ]))
      : (!_ctx.pasi.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Fără informații de flux."))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pasi, (p, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "step"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "step-ic",
                    style: _normalizeStyle({ background: p.color })
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "#fff"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(p.icon), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ], 4),
                  (!p.last)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(p.rol), 1),
                    _createElementVNode("span", {
                      class: "step-status",
                      style: _normalizeStyle({ color: p.color })
                    }, _toDisplayString(p.statusLabel), 5)
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(p.nume), 1),
                  (p.dataFmt)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(p.dataFmt), 1))
                    : _createCommentVNode("", true),
                  (p.nota)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "„" + _toDisplayString(p.nota) + "\"", 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
  ]))
}